// @flow

import * as React from 'react';
import Switch from 'sail/Switch';
import {useOverlay} from 'docs/data';
import type {Account, Article} from 'docs/data';
import {XRaySidebarSection} from './XRaySidebarSection';

type OverlaysProps = {|
  account: Account,
  article: Article,
|};

export const Overlays = ({account, article}: OverlaysProps) => {
  const [overlays, setOverlay] = useOverlay();

  return (
    <XRaySidebarSection title="Overlays">
      <Switch
        size="small"
        value={overlays.errors}
        onChange={(value) => setOverlay('errors', value)}
        label="Errors"
      />

      <Switch
        size="small"
        value={overlays.partials}
        onChange={(value) => setOverlay('partials', value)}
        label="Partials"
      />
    </XRaySidebarSection>
  );
};
